module.exports = __webpack_public_path__ + "static/media/minimap.ce17e2d3.PNG";